angular.module('avant.filters').filter 'OrNewDate',
  -> (input) -> input || (new Date())
